import store from '../stores'
import { MessageBox } from 'element-ui'

function showAccountChange() {
  const d = document.querySelector('.account_change_pop_wrap')
  if (d) {
    d.remove()
  }
  const html = `
    <div class="account_change_pop_wrap">
      <div class="account_change_pop_mask"></div>
      <div class="account_change_pop_body">
        <div class="account_change_pop_title">
          <i class="el-icon-warning"></i>授权账号已发生变化，请刷新页面
        </div>
        <div>
          <button class="account_change_pop_btn account_change_pop_ok_btn" type="button">确定</button>
          <button class="account_change_pop_btn account_change_pop_cancel_btn" type="button">取消</button>
        </div>
      </div>
    </div>`
  document.body.insertAdjacentHTML('beforeend', html)
  document.querySelector('.account_change_pop_ok_btn').addEventListener('click', () => {
    location.reload()
  })
  document.querySelector('.account_change_pop_cancel_btn').addEventListener('click', () => {
    document.querySelector('.account_change_pop_wrap').remove()
  })
}

window.addEventListener('storage', function (event) {
  if (event.key === 'account_info_key' && event.storageArea === localStorage) {
    const newValue = JSON.parse(event.newValue)
    const cid1 = newValue.proxyCid
    const cid2 = store.getters.getChildrenAccountInfo.proxyCid
    if (cid1 && cid2 && cid1 !== cid2) {
      showAccountChange()
    }
  }
});
